var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable @typescript-eslint/no-namespace */
import * as React from 'react';
import { isRpcError, RpcErrorCode } from '@leanprover/infoview-api';
import { EditorContext } from './contexts';
export var DocumentPosition;
(function (DocumentPosition) {
    function isEqual(p1, p2) {
        return p1.uri === p2.uri && p1.line === p2.line && p1.character === p2.character;
    }
    DocumentPosition.isEqual = isEqual;
    function toTdpp(p) {
        return { textDocument: { uri: p.uri },
            position: { line: p.line, character: p.character } };
    }
    DocumentPosition.toTdpp = toTdpp;
    function toString(p) {
        return "".concat(p.uri, ":").concat(p.line + 1, ":").concat(p.character);
    }
    DocumentPosition.toString = toString;
})(DocumentPosition || (DocumentPosition = {}));
export var PositionHelpers;
(function (PositionHelpers) {
    function isLessThanOrEqual(p1, p2) {
        return p1.line < p2.line || (p1.line === p2.line && p1.character <= p2.character);
    }
    PositionHelpers.isLessThanOrEqual = isLessThanOrEqual;
})(PositionHelpers || (PositionHelpers = {}));
export var RangeHelpers;
(function (RangeHelpers) {
    function contains(range, pos, ignoreCharacter) {
        if (!ignoreCharacter) {
            if (pos.line === range.start.line && pos.character < range.start.character)
                return false;
            if (pos.line === range.end.line && pos.character > range.end.character)
                return false;
        }
        return range.start.line <= pos.line && pos.line <= range.end.line;
    }
    RangeHelpers.contains = contains;
})(RangeHelpers || (RangeHelpers = {}));
// https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript
export function escapeHtml(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
/** @deprecated (unused) */
export function colorizeMessage(goal) {
    return goal
        .replace(/^([|⊢]) /mg, '<strong class="goal-vdash">$1</strong> ')
        .replace(/^(\d+ goals|1 goal)/mg, '<strong class="goal-goals">$1</strong>')
        .replace(/^(context|state):/mg, '<strong class="goal-goals">$1</strong>:')
        .replace(/^(case) /mg, '<strong class="goal-case">$1</strong> ')
        .replace(/^([^:\n< ][^:\n⊢{[(⦃]*) :/mg, '<strong class="goal-hyp">$1</strong> :');
}
export function basename(path) {
    var bn = path.split(/[\\/]/).pop();
    if (bn)
        return bn;
    else
        return '';
}
/**
 * A specialization of {@link React.useEffect} which executes `f` with the event data whenever
 * `ev` fires. */
export function useEvent(ev, f, dependencies) {
    React.useEffect(function () {
        var h = ev.on(f);
        return function () { return h.dispose(); };
    }, dependencies);
}
export function useEventResult(ev, f) {
    var fn = f !== null && f !== void 0 ? f : (function (x) { return x; });
    var _a = __read(React.useState(ev.current ? fn(ev.current) : undefined), 2), s = _a[0], setS = _a[1];
    useEvent(ev, function (newV) { return setS(newV ? fn(newV) : undefined); });
    return s;
}
export function useServerNotificationEffect(method, f, deps) {
    var ec = React.useContext(EditorContext);
    React.useEffect(function () {
        void ec.api.subscribeServerNotifications(method).catch(function (ex) {
            console.error("Failed subscribing to server notification '".concat(method, "': ").concat(ex));
        });
        var h = ec.events.gotServerNotification.on(function (_a) {
            var _b = __read(_a, 2), thisMethod = _b[0], params = _b[1];
            if (thisMethod !== method)
                return;
            f(params);
        });
        return function () {
            h.dispose();
            void ec.api.unsubscribeServerNotifications(method);
        };
    }, deps);
}
/**
 * Returns the same tuple as `setState` such that whenever a server notification with `method`
 * arrives at the editor, the state will be updated according to `f`.
 */
export function useServerNotificationState(method, initial, f, deps) {
    var _a = __read(React.useState(initial), 2), s = _a[0], setS = _a[1];
    useServerNotificationEffect(method, function (params) { return void f(params).then(function (g) { return setS(g); }); }, deps);
    return [s, setS];
}
export function useClientNotificationEffect(method, f, deps) {
    var ec = React.useContext(EditorContext);
    React.useEffect(function () {
        void ec.api.subscribeClientNotifications(method).catch(function (ex) {
            console.error("Failed subscribing to client notification '".concat(method, "': ").concat(ex));
        });
        var h = ec.events.sentClientNotification.on(function (_a) {
            var _b = __read(_a, 2), thisMethod = _b[0], params = _b[1];
            if (thisMethod !== method)
                return;
            f(params);
        });
        return function () {
            h.dispose();
            void ec.api.unsubscribeClientNotifications(method);
        };
    }, deps);
}
/**
 * Like {@link useServerNotificationState} but for client->server notifications sent by the editor.
 */
export function useClientNotificationState(method, initial, f, deps) {
    var _a = __read(React.useState(initial), 2), s = _a[0], setS = _a[1];
    useClientNotificationEffect(method, function (params) {
        setS(function (state) { return f(state, params); });
    }, deps);
    return [s, setS];
}
/**
 * Returns `[{ isPaused, setPaused }, tPausable, tRef]` s.t.
 * - `[isPaused, setPaused]` are the paused status state
 * - for as long as `isPaused` is set, `tPausable` holds its initial value (the `t` passed before pausing)
 *   rather than updates with changes to `t`.
 * - `tRef` can be used to overwrite the paused state
 *
 * To pause child components, `startPaused` can be passed in their props.
 */
export function usePausableState(startPaused, t) {
    var _a = __read(React.useState(startPaused), 2), isPaused = _a[0], setPaused = _a[1];
    var old = React.useRef(t);
    if (!isPaused)
        old.current = t;
    return [{ isPaused: isPaused, setPaused: setPaused }, old.current, old];
}
/**
 * Adds a unique `key` property to each element in `elems` using
 * the values of (possibly non-injective) `getId`.
 */
export function addUniqueKeys(elems, getId) {
    var keys = {};
    return elems.map(function (el) {
        var id = getId(el);
        keys[id] = (keys[id] || 0) + 1;
        return __assign({ key: "".concat(id, ":").concat(keys[id]) }, el);
    });
}
/** Like `React.forwardRef`, but also allows using the ref inside the forwarding component.
 * Adapted from https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd */
export function forwardAndUseRef(render) {
    return React.forwardRef(function (props, ref) {
        var thisRef = React.useRef(null);
        return render(props, thisRef, function (v) {
            thisRef.current = v;
            if (!ref)
                return;
            if (typeof ref === 'function') {
                ref(v);
            }
            else {
                ref.current = v;
            }
        });
    });
}
export var LogicalDomContext = React.createContext({ registerDescendant: function () { return function () { }; } });
/** Suppose a component B appears as a React child of the component A. For layout reasons,
 * we sometimes don't want B to appear as an actual child of A in the DOM. We may still however
 * want to carry out `contains` checks as if B were there, i.e. according to the React tree
 * structure rather than the DOM structure. While React already correctly propagates DOM events
 * up this logical tree, other functionality such as `contains` is not provided.
 *
 * This method creates a {@link LogicalDomElement} corresponding to the given {@link HTMLElement}
 * which provides the missing functionality for that element. For this to work, the element
 * must be wrapped in a {@link LogicalDomContext} set to the {@link LogicalDomStorage} returned
 * from this call.
 *
 * Additionally, any component which actually introduces React-but-not-DOM children must
 * call `registerDescendant` in the {@link LogicalDomContext}. */
export function useLogicalDom(ref) {
    var parentCtx = React.useContext(LogicalDomContext);
    React.useEffect(function () {
        if (ref.current) {
            var h_1 = parentCtx.registerDescendant(ref.current);
            return function () { return h_1(); };
        }
    }, [ref, parentCtx]);
    var descendants = React.useRef(new Set());
    var contains = function (el) {
        var e_1, _a;
        if (ref.current && ref.current.contains(el))
            return true;
        try {
            for (var _b = __values(descendants.current), _c = _b.next(); !_c.done; _c = _b.next()) {
                var d = _c.value;
                if (d.contains(el))
                    return true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    var registerDescendant = function (el) {
        var h = parentCtx.registerDescendant(el);
        if (el)
            descendants.current.add(el);
        return function () {
            if (el)
                descendants.current.delete(el);
            h();
        };
    };
    return [
        React.useMemo(function () { return ({ contains: contains }); }, [ref]),
        React.useMemo(function () { return ({ registerDescendant: registerDescendant }); }, [parentCtx])
    ];
}
/**
 * An effect which calls `onClickOutside` whenever an element not logically descending from `ld`
 * (see {@link useLogicalDom}) is clicked. Note that `onClickOutside` is not called on clicks
 * on the scrollbar since these should usually not impact the app's state. */
export function useOnClickOutside(ld, onClickOutside) {
    React.useEffect(function () {
        var onClickAnywhere = function (e) {
            if (e.target instanceof Node && !ld.contains(e.target)) {
                if (e.target instanceof Element && e.target.tagName === 'HTML') {
                    // then user might be clicking in a scrollbar, otherwise
                    // e.target would be a tag other than 'HTML'
                }
                else
                    onClickOutside(e);
            }
        };
        document.addEventListener('pointerdown', onClickAnywhere);
        return function () { return document.removeEventListener('pointerdown', onClickAnywhere); };
    }, [ld, onClickOutside]);
}
/** Sends an exception object to a throwable error.
 * Maps JSON Rpc errors to throwable errors.
 */
export function mapRpcError(err) {
    if (isRpcError(err)) {
        return new Error("Rpc error: ".concat(RpcErrorCode[err.code], ": ").concat(err.message));
    }
    else if (!(err instanceof Error)) {
        return new Error("Unrecognised error ".concat(JSON.stringify(err)));
    }
    else {
        return err;
    }
}
/** Catch handler for RPC methods that just returns undefined if the method is not found.
 * This is useful for compatibility with versions of Lean that do not yet have the given RPC method.
*/
export function discardMethodNotFound(e) {
    if (isRpcError(e) && (e.code === RpcErrorCode.MethodNotFound)) {
        return undefined;
    }
    else {
        throw mapRpcError(e);
    }
}
export function useAsyncWithTrigger(fn, deps) {
    var _this = this;
    if (deps === void 0) { deps = []; }
    var asyncState = React.useRef({ state: 'notStarted' });
    var asyncStateDeps = React.useRef([]);
    // A monotonically increasing counter.
    var tick = React.useRef(0);
    // This is bumped up to the current `tick` whenever `asyncState.current` is assigned,
    // in order to trigger a React update.
    var _a = __read(React.useState(0), 2), _ = _a[0], setUpdate = _a[1];
    var trigger = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var startTick, set;
        return __generator(this, function (_a) {
            if (asyncState.current.state === 'loading' || asyncState.current.state === 'resolved')
                return [2 /*return*/];
            tick.current += 1;
            asyncState.current = { state: 'loading' };
            setUpdate(tick.current);
            tick.current += 1;
            startTick = tick.current;
            set = function (state) {
                if (tick.current === startTick) {
                    asyncState.current = state;
                    setUpdate(tick.current);
                }
            };
            return [2 /*return*/, fn().then(function (value) { return set({ state: 'resolved', value: value }); }, function (error) { return set({ state: 'rejected', error: error }); })];
        });
    }); }, deps);
    var depsTheSame = asyncStateDeps.current.length === deps.length &&
        asyncStateDeps.current.every(function (d, i) { return Object.is(d, deps[i]); });
    if (!depsTheSame) {
        tick.current += 1;
        asyncState.current = { state: 'notStarted' };
        asyncStateDeps.current = deps;
        setUpdate(tick.current);
    }
    return [asyncState.current, trigger];
}
/** This React hook will run the given promise function `fn` whenever the deps change
 * and use it to update the status and result when the promise resolves.
 *
 * This function prevents race conditions if the requests resolve in a
 * different order to that which they were requested in:
 *
 * - Request 1 is sent with, say, line=42.
 * - Request 2 is sent with line=90.
 * - Request 2 returns with diags=[].
 * - Request 1 returns with diags=['error'].
 *
 * Without `useAsync` we would now return the diagnostics for line 42 even though we're at line 90.
 *
 * When the deps change, the function immediately returns `{ state: 'loading' }`.
 */
export function useAsync(fn, deps) {
    if (deps === void 0) { deps = []; }
    var _a = __read(useAsyncWithTrigger(fn, deps), 2), state = _a[0], trigger = _a[1];
    if (state.state === 'notStarted') {
        void trigger();
        return { state: 'loading' };
    }
    else {
        return state;
    }
}
